export const MODULE_NAME = "notifications";
export const MODULE_UI_NAME = "Notifications";
